<template>
  <SectionPageShell section="ads" title="Werbeanzeigen">
    <div class="row">
      <div class="col-12 col-3">
        <router-link v-if="userStore.user.isStaffMember()" class="btn btn-primary" :to="{name:'ads.create'}">Werbeanzeige anlegen</router-link>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="alert alert-info mb-0">
          Die Erstellung und Bearbeitung von Werbeanzeigen ist aktuell nicht über die Oberfläche möglich.
          Für Änderungen wenden Sie sich bitte an den
          <router-link :to="{name: 'account.support'}">Support</router-link>.
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <DataTable
          :paginator="true"
          :rows="20"
          :totalRecords="adStore.items.length"
          dataKey="id"
          :value="adStore.items"
          :loading="adStore.loading"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
        >
          <TableColumn field="id" header="ID" />
          <TableColumn field="title" header="Titel" />
          <TableColumn field="link" header="Link" />
          <TableColumn header="Aktionen">
            <template #body="{data}">
              <div class="d-flex align-items-center">
                <router-link class="me-3 d-inline-flex align-items-center" title="anzeigen" :to="{name:'ads.show', params: {ad_id: data.id}}">
                  <ActionIcon icon="fa-pro-solid:eye" />
                </router-link>
                <router-link v-if="userStore.user.isStaffMember()" class="d-inline-flex align-items-center" title="bearbeiten" :to="{name:'ads.edit', params: {ad_id: data.id}}">
                  <ActionIcon icon="fa-pro-solid:pencil" />
                </router-link>
                <router-link class="me-3 d-inline-flex align-items-center" title="statistik" :to="{name:'ads.stats', params: {ad_id: data.id}}">
                  <ActionIcon icon="fa-pro-solid:chart-pie" />
                </router-link>
              </div>
            </template>
          </TableColumn>
        </DataTable>
      </div>
    </div>
  </SectionPageShell>
</template>

<script>
import ActionIcon from "@/components/general/ActionIcon.vue";
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import {useAdsStore} from "@/stores/ads";
import {useUserStore} from "@/stores/user";

export default {
  components: {
    ActionIcon,
    SectionPageShell,
  },
  setup() {
    return {
      adStore: useAdsStore(),
      userStore: useUserStore(),
    }
  },
  created() {
    this.adStore.index()
  },
}
</script>
